<template>
  <sui-form-field :disabled="!drives.length" :error="isInvalid" required>
    <label>
      {{field.label}}
    </label>
    <sui-dropdown :placeholder="fieldPlaceholder" :options="driveList" v-model="$attrs.value" selection @input="onInput" />
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  import utils from '@/utils'

  export default {
    name: 'FormProviderDrives',
    mixins: [
      FormField,
    ],
    props: {
      drives: {
        type: Array,
        required: false,
      },
    },
    computed: {
      fieldPlaceholder() {
        return this.drives.length ? 'Select...' : 'No available drives'
      },
      driveList() {
        return this.drives.map(drive => {
          // {id: 'id1', owner: {user: {displayName: 'text1'}}, quota: {remaining: 1, total: 2}},
          return {
            value: drive.id,
            text: drive.owner.user.displayName + ' — Free: ' + utils.prettyBytes(drive.quota.total - drive.quota.used) + ' of ' + utils.prettyBytes(drive.quota.total),
          }
        })
      },
    },
    watch: {
      drives() {
        if (this.drives.length) {
          this.set(this.drives[0].id)
          this.entity.auth.accessId = this.drives[0].id
        }
      }
    },
  }
</script>
